var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper-choice-student-third"},[_c('TemplateDataGrid',_vm._b({ref:"grid",attrs:{"gridId":"PaperChoiceStudentThird"}},'TemplateDataGrid',_vm.gridParams,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }